module.exports = __webpack_public_path__ + "static/media/IMG_5028.0b504930.JPG";